import { Link } from 'react-router-dom';
import type { ItemSummary } from '../api/types';
import { formatDate } from '../format';
import { strings } from '../strings';
import { TypeTag } from './Badges';

export function ResultList({ tenant, items }: { tenant: string; items: ItemSummary[] }) {
  return (
    <ul className="m-0 list-none space-y-3 p-0">
      {items.map((item) => (
        <li key={item.id} className="card">
          <TypeTag type={item.type} />
          <h3 className="m-0 mt-1">
            <Link to={`/t/${encodeURIComponent(tenant)}/items/${encodeURIComponent(item.id)}`}>
              {item.name || item.id}
            </Link>
          </h3>
          {item.description && <p className="m-0 mt-1 line-clamp-2">{item.description}</p>}
          {item.updatedAt && (
            <p className="m-0 mt-2 text-small text-neutral-muted">{strings.search.updated(formatDate(item.updatedAt))}</p>
          )}
        </li>
      ))}
    </ul>
  );
}
